import React from 'react';
import './TodayStats.scss';

export interface TodayStatsData {
  payments: number;
  tasks: number;
  arrears: number;
  warnings: number;
  vacancy: number;
  newTenants: number;
}

interface TodayStatsProps {
  data?: TodayStatsData;
}

const mockData: TodayStatsData = {
  payments: 32,
  tasks: 48,
  arrears: 12,
  warnings: 19,
  vacancy: 7,
  newTenants: 12
};

const TodayStats: React.FC<TodayStatsProps> = ({
                                                 data = mockData
                                               }) => {
  const baseClass = 'TodayStats';

  const statsConfig = [
    {
      key: 'payments' as keyof TodayStatsData,
      label: 'Payments',
      color: '#76C102',
      backgroundColor: 'rgba(118, 193, 2, 0.2)'
    },
    {
      key: 'tasks' as keyof TodayStatsData,
      label: 'Tasks',
      color: '#105E96',
      backgroundColor: 'rgba(16, 94, 150, 0.15)'
    },
    {
      key: 'arrears' as keyof TodayStatsData,
      label: 'Arrears',
      color: '#FB2F54',
      backgroundColor: 'rgba(251, 47, 84, 0.2)'
    },
    {
      key: 'warnings' as keyof TodayStatsData,
      label: 'Warnings',
      color: '#FF9C07',
      backgroundColor: 'rgba(255, 156, 7, 0.2)'
    },
    {
      key: 'vacancy' as keyof TodayStatsData,
      label: 'Vacancy',
      color: '#5CB2EF',
      backgroundColor: 'rgba(92, 178, 239, 0.2)'
    },
    {
      key: 'newTenants' as keyof TodayStatsData,
      label: 'New tenants',
      color: '#637381',
      backgroundColor: '#DFE3E8'
    }
  ];

  // Розбиваємо на три колонки по два елементи
  const leftColumn = statsConfig.slice(0, 2);
  const middleColumn = statsConfig.slice(2, 4);
  const rightColumn = statsConfig.slice(4, 6);

  const renderStatsColumn = (columnStats: typeof statsConfig) => (
    <div className={`${baseClass}__column`}>
      {columnStats.map((stat) => (
        <div
          key={stat.key}
          className={`${baseClass}__row`}
          style={{ backgroundColor: stat.backgroundColor }}
        >
          <div className={`${baseClass}__label`}>
            {stat.label}
          </div>
          <div
            className={`${baseClass}__value`}
            style={{
              backgroundColor: '#FFFFFF',
              border: `4px solid ${stat.color}`
            }}
          >
            {data[stat.key]}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className={baseClass}>
      <h3 className={`${baseClass}__title`}>Today</h3>
      <div className={`${baseClass}__divider`} />

      <div className={`${baseClass}__content`}>
        {renderStatsColumn(leftColumn)}
        {renderStatsColumn(middleColumn)}
        {renderStatsColumn(rightColumn)}
      </div>
    </div>
  );
};

export default TodayStats;